/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity, userSupportedTypes } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export const MULTI_VALUE_MULTIPLE_LINE = "multiple-line";
export const MULTI_VALUE_ONE_LINE = "one-line";

export default declareLinkedEntity({
    entity: "actionInputDefs",
    graphQL: "ActionInputDef",
    name: "Action Input Definition",
    defaultOrder: ['key', 'name'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: 'actionInputDefs',
    defaultTitle: (data) => {
        return data['name'] ? data['name'] : data['key'];
    },
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Action Input Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (actionDef) => {
                return actionDef['channelDef_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        actionDef: {
            name: "Action Definition",
            type: "relation",
            to: () => types['actionDefs'],
            defaultValue: (actionDef) => {
                return actionDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ['channelDef'],
        },
        key: {
            name: "Key",
            type: "string",
            required: true,
            trim: true,
            validations: {
                matchRegexp: /^[a-zA-Z0-9_]+$/,
            },
            isPublic: true,
        },
        name: {
            name: "Name",
            trim: true,
            type: "string",
            translatable: true,
            defaultValue: "",
            isPublic: true,
        },
        required: {
            name: "Required",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: "string",
            values: userSupportedTypes,
            isPublic: true,
        },
        testValue: {
            name: "Test Value",
            type: "string",
            defaultValue: "",
        },
        multiValueStyle: {
            name: "Multi value style",
            type: "enum",
            defaultValue: MULTI_VALUE_ONE_LINE,
            values: {
                [MULTI_VALUE_MULTIPLE_LINE]: {
                    name: 'Multiple rows',
                    description: 'Take multi-value as multiple rows.',
                },
                [MULTI_VALUE_ONE_LINE]: {
                    name: 'One row',
                    description: 'Take multi-value as one row.'
                },
            },
        },
        entityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            isPublic: true,
        },
        fieldDef: {
            name: "Field Definition",
            type: "relation",
            to: () => types['fieldDefs'],
            isPublic: true,
            relativeTo: ['fieldEntityDef'],
            visibility: (data) => { return data['entityDef'] || data['entityDef'] ? true : false; },
        },
        fieldEntityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            isPublic: true,
            visibility: (data) => { return data['entityDef'] || data['entityDef_id'] ? true : false; },
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: ""
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }

});
